import React from 'react';
import { Link } from 'gatsby';
import { Icon } from 'src/components/shared';

interface HeaderLogoProps {
    entitled: boolean;
    shopifyUrl: string | undefined;
}

export const HeaderLogo = ({ entitled, shopifyUrl }: HeaderLogoProps) => {
    const logoProps = {
        name: 'pv-logo-name',
        size: 36,
    };

    return (
        <div>
            {entitled ? (
                <Link to="/my-plan" title="Return to the P.volve homepage">
                    <Icon {...logoProps} />
                </Link>
            ) : (
                <a href={`${shopifyUrl}/`} title="Return to the P.volve homepage">
                    <Icon {...logoProps} />
                </a>
            )}
        </div>
    );
};

export default HeaderLogo;
